import {createProjectModel} from 'crm/utils/project-model'
import {customerFissions, fissionInfo, fissionActivity} from '../../services'

const model = createProjectModel({
    projectNamespace: 'fissionData',

    state: {
        tableData: null,
    },

    effects: {
        *fissionInfo({payload}, {call}) {
            return yield call(fissionInfo, payload)
        },

        *fissionActivity({payload}, {call}) {
            return yield call(fissionActivity, payload)
        },

        *customerFissions(xx, {call, select, put}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(customerFissions, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = res?.pagination?.rows_found ?? 0
                },
            })
        },
    },
})

export default model
